import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { useMemo } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B_Other() {
    const { useLang, useState, useRouter, useEffect } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const tabs: any = [t('secB_tab1'), t('secB_tab2'), t('secB_tab3')];
    const LOCALE_SITES = ['za'];
    const IMG_MAP: any = {
        us: '',
        au: '_au',
        za: '_za',
    };
    let cards: any = {
        0: [
            {
                img: `/responsive/picture/outdoor-recreation/2_1_1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgDesktop: `/responsive/picture/outdoor-recreation/2_1_1_1366${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgPad: `/responsive/picture/outdoor-recreation/2_1_1_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/outdoor-recreation/2_1_1_375${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                tag: t('secB_tab1_tag1'),
            },
            {
                img: `/responsive/picture/outdoor-recreation/2_1_2${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgDesktop: `/responsive/picture/outdoor-recreation/2_1_2_1366${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgPad: `/responsive/picture/outdoor-recreation/2_1_2_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/outdoor-recreation/2_1_2_375${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                tag: t('secB_tab1_tag2'),
            },
            {
                img: `/responsive/picture/outdoor-recreation/2_1_3${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgDesktop: `/responsive/picture/outdoor-recreation/2_1_3_1366${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgPad: `/responsive/picture/outdoor-recreation/2_1_3_768${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                imgMobile: `/responsive/picture/outdoor-recreation/2_1_3_375${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
                tag: t('secB_tab1_tag3'),
            },
            {
                img: `/responsive/picture/outdoor-recreation/2_1_4${[LOCALE_SITES.includes(locale) ? `_${locale}` : '']}.jpg`,
                imgDesktop: `/responsive/picture/outdoor-recreation/2_1_4_1366${[LOCALE_SITES.includes(locale) ? `_${locale}` : '']}.jpg`,
                imgPad: `/responsive/picture/outdoor-recreation/2_1_4_768${[LOCALE_SITES.includes(locale) ? `_${locale}` : '']}.jpg`,
                imgMobile: `/responsive/picture/outdoor-recreation/2_1_4_375${[LOCALE_SITES.includes(locale) ? `_${locale}` : '']}.jpg`,
                tag: t('secB_tab1_tag4'),
            },
        ],
        1: [
            {
                img: '/responsive/picture/outdoor-recreation/2_2_1.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_2_1_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_2_1_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_2_1_375.jpg',
                tag: t('secB_tab2_tag1'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/2_2_2.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_2_2_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_2_2_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_2_2_375.jpg',
                tag: t('secB_tab2_tag2'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/2_2_4.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_2_4_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_2_4_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_2_4_375.jpg',
                tag: t('secB_tab2_tag3'),
            },
        ],
        2: [
            {
                img: '/responsive/picture/outdoor-recreation/2_3_1.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_3_1_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_3_1_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_3_1_375.jpg',
                tag: t('secB_tab3_tag1'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/2_3_2.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_3_2_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_3_2_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_3_2_375.jpg',
                tag: t('secB_tab3_tag2'),
            },
            {
                img: '/responsive/picture/outdoor-recreation/2_3_3.jpg',
                imgDesktop: '/responsive/picture/outdoor-recreation/2_3_3_1366.jpg',
                imgPad: '/responsive/picture/outdoor-recreation/2_3_3_768.jpg',
                imgMobile: '/responsive/picture/outdoor-recreation/2_3_3_375.jpg',
                tag: t('secB_tab3_tag3'),
            },
        ],
    };

    if (locale === 'kr') {
        cards = {
            0: [
                {
                    img: `/responsive/picture/outdoor-recreation/2_1_1_kr.jpg`,
                    imgDesktop: `/responsive/picture/outdoor-recreation/2_1_1_1366_kr.jpg`,
                    imgPad: `/responsive/picture/outdoor-recreation/2_1_1_768_kr.jpg`,
                    imgMobile: `/responsive/picture/outdoor-recreation/2_1_1_375_kr.jpg`,
                    tag: t('secB_tab1_tag1'),
                },
                {
                    img: `/responsive/picture/outdoor-recreation/2_1_2_kr.jpg`,
                    imgDesktop: `/responsive/picture/outdoor-recreation/2_1_2_1366_kr.jpg`,
                    imgPad: `/responsive/picture/outdoor-recreation/2_1_2_768_kr.jpg`,
                    imgMobile: `/responsive/picture/outdoor-recreation/2_1_2_375_kr.jpg`,
                    tag: t('secB_tab1_tag2'),
                },
                {
                    img: `/responsive/picture/outdoor-recreation/2_1_3_kr.jpg`,
                    imgDesktop: `/responsive/picture/outdoor-recreation/2_1_3_1366_kr.jpg`,
                    imgPad: `/responsive/picture/outdoor-recreation/2_1_3_768_kr.jpg`,
                    imgMobile: `/responsive/picture/outdoor-recreation/2_1_3_375_kr.jpg`,
                    tag: t('secB_tab1_tag3'),
                },
                {
                    img: `/responsive/picture/outdoor-recreation/2_1_4_kr.jpg`,
                    imgDesktop: `/responsive/picture/outdoor-recreation/2_1_4_1366_kr.jpg`,
                    imgPad: `/responsive/picture/outdoor-recreation/2_1_4_768_kr.jpg`,
                    imgMobile: `/responsive/picture/outdoor-recreation/2_1_4_375_kr.jpg`,
                    tag: t('secB_tab1_tag4'),
                },
            ],
            1: [
                {
                    img: '/responsive/picture/outdoor-recreation/2_2_1_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_2_1_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_2_1_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_2_1_375_kr.jpg',
                    tag: t('secB_tab2_tag1'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/2_2_2_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_2_2_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_2_2_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_2_2_375_kr.jpg',
                    tag: t('secB_tab2_tag2'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/2_2_4_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_2_4_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_2_4_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_2_4_375_kr.jpg',
                    tag: t('secB_tab2_tag3'),
                },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/2_3_1_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_3_1_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_3_1_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_3_1_375_kr.jpg',
                    tag: t('secB_tab3_tag1'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/2_3_2_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_3_2_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_3_2_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_3_2_375_kr.jpg',
                    tag: t('secB_tab3_tag2'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/2_3_3_kr.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_3_3_1366_kr.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_3_3_768_kr.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_3_3_375_kr.jpg',
                    tag: t('secB_tab3_tag3'),
                },
            ],
        };
    }

    if (['au'].includes(locale)) {
        cards = {
            0: [
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776352721/2_1_1_1366_au.png',
                    imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776352721/2_1_1_1366_au.png',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776727484/2_1_1_768_au.png',
                    imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777117360/2_1_1_375_au.png',
                    tag: t('secB_tab1_tag1'),
                },
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776367165/2_1_2_1366_au.png',
                    imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776367165/2_1_2_1366_au.png',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776752252/2_1_2_768_au.png',
                    imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777124261/2_1_2_375_au.png',
                    tag: t('secB_tab1_tag2'),
                },
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776374544/2_1_3_1366_au.png',
                    imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776374544/2_1_3_1366_au.png',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776759955/2_1_3_768_au.png',
                    imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777130898/2_1_3_375_au.png',
                    tag: t('secB_tab1_tag3'),
                },
            ],
            1: [
                {
                    // img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776381681/2_2_1_1366_au.png',
                    // imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776381681/2_2_1_1366_au.png',
                    // imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776768628/2_2_1_768_au.png',
                    // imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777137731/2_2_1_375_au.png',
                    img: '/responsive/picture/outdoor-recreation/2_2_na.jpg',
                    tag: t('secB_tab2_tag1'),
                },
                // {
                //     img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776389058/2_2_2_1366_au.png',
                //     imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776389058/2_2_2_1366_au.png',
                //     imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776780163/2_2_2_768_au.png',
                //     imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777145483/2_2_2_375_au.png',
                //     tag: t('secB_tab2_tag2'),
                // },
            ],
            2: [
                {
                    img: '/responsive/picture/outdoor-recreation/2_3_2.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_3_2_1366.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_3_2_768.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_3_2_375.jpg',
                    tag: t('secB_tab3_tag2'),
                },
                // {
                //     img: '/responsive/picture/outdoor-recreation/2_3_3.jpg',
                //     imgDesktop: '/responsive/picture/outdoor-recreation/2_3_3_1366.jpg',
                //     imgPad: '/responsive/picture/outdoor-recreation/2_3_3_768.jpg',
                //     imgMobile: '/responsive/picture/outdoor-recreation/2_3_3_375.jpg',
                //     tag: t('secB_tab3_tag3'),
                // },
            ],
            3: [
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776398347/2_4_1_1366_au.png',
                    imgDesktop: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776398347/2_4_1_1366_au.png',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716776787838/2_4_1_768_au.png',
                    imgMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716777153981/2_4_1_375_au.png',
                    tag: t('secB_tab4_tag1'),
                },
                {
                    img: '/responsive/picture/outdoor-recreation/2_4_2.jpg',
                    imgDesktop: '/responsive/picture/outdoor-recreation/2_4_2_1366.jpg',
                    imgPad: '/responsive/picture/outdoor-recreation/2_4_2_768.jpg',
                    imgMobile: '/responsive/picture/outdoor-recreation/2_4_2_375.jpg',
                    tag: t('secB_tab4_tag2'),
                },
            ],
        };
        tabs.push(t('secB_tab4'));
    }

    const [lists, setLists] = useState(cards[active]);

    useEffect(() => {
        setLists(cards[active]);
    }, [active]);

    const renderSwiper = useMemo(() => {
        return (
            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Navigation, Pagination, Autoplay]}
                navigation={lists?.length > 1}
                pagination={lists?.length > 1}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                loop={lists?.length > 1}
                autoplay={{
                    disableOnInteraction: false,
                    delay: 4000,
                }}
            >
                {lists?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <EFPicture src={item?.img} srcDesktop={item?.imgDesktop} srcPad={item?.imgPad} srcMobile={item?.imgMobile} alt={item?.title} />
                        </div>
                        <span className="item-tag">{item?.tag}</span>
                    </SwiperSlide>
                ))}
            </Swiper>
        );
    }, [active, lists]);

    return (
        <div id="outdoor-recreation-B" className={`outdoor-recreation-B ${css['outdoor-recreation-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secB_title')}</p>
                </div>
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                            {tab}
                        </li>
                    ))}
                </ul>
                <p className="tab-desc">{t(`secB_tab${active + 1}_desc`)}</p>
                {renderSwiper}
            </div>
        </div>
    );
}
